
/**
 * AiAssistantIcon component - Uses the AiAssistant.png image as the icon
 */
const AiAssistantIcon = ({ width = 24, height = 24, className, isAllBlack = false }) => {

  if (isAllBlack) {
    return (
      <div className={className} style={{ height: `${height}px`, width: `${width}px` }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 0C5.38105 0 0 5.38074 0 12V24H12C18.6189 24 24 18.6193 24 12C24 5.38074 18.6193 0 12 0ZM12 22.1053H1.89474V12C1.89474 11.6965 1.91941 11.3931 1.94408 11.0896C2.14638 8.74093 4.01642 6.8191 6.38983 6.66859H6.66861C9.29611 6.66859 11.4178 8.68914 11.5189 11.3166C11.5683 12.4022 11.2673 13.389 10.7098 14.2229C11.3167 14.5757 11.7706 15.0568 12.0223 15.6119C12.301 15.0568 12.755 14.5757 13.3347 14.2229C12.7796 13.389 12.5009 12.4047 12.5256 11.3166C12.6514 8.68914 14.7484 6.66859 17.3759 6.66859H17.6547C20.0034 6.79441 21.8734 8.71383 22.1004 11.0896C22.1251 11.3931 22.1498 11.6966 22.1498 12C22.1054 17.5584 17.5582 22.1053 12 22.1053Z" fill="#1C1C1C" />
          <path d="M9.77675 11.7216C9.77675 13.8113 6.64355 13.8113 6.64355 11.7216C6.64355 9.63446 9.77675 9.63446 9.77675 11.7216Z" fill="#1C1C1C" />
          <path d="M17.3559 11.7216C17.3559 13.8113 14.2227 13.8113 14.2227 11.7216C14.2227 9.63446 17.3559 9.63446 17.3559 11.7216Z" fill="#1C1C1C" />
        </svg>
      </div>
    )
  }

  return (
    <div className={className} style={{ height: `${height}px`, width: `${width}px` }}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 27 28" fill="none">
        <path d="M13.5 0C6.05368 0 0 6.14941 0 13.7143V27.4286H13.5C20.9463 27.4286 27 21.2792 27 13.7143C27 6.14941 20.9467 0 13.5 0ZM13.5 25.2632H2.13158V13.7143C2.13158 13.3675 2.15933 13.0207 2.18709 12.6739C2.41468 9.98963 4.51847 7.79325 7.18855 7.62125H7.50219C10.4581 7.62125 12.845 9.93044 12.9588 12.9333C13.0143 14.1739 12.6757 15.3017 12.0485 16.2547C12.7313 16.6579 13.242 17.2077 13.525 17.8421C13.8387 17.2077 14.3494 16.6579 15.0016 16.2547C14.3771 15.3018 14.0635 14.1767 14.0913 12.9333C14.2328 9.93044 16.5919 7.62125 19.5479 7.62125H19.8615C22.5038 7.76504 24.6076 9.95867 24.863 12.6739C24.8907 13.0207 24.9185 13.3675 24.9185 13.7143C24.8685 20.0667 19.753 25.2632 13.5 25.2632Z" fill="url(#paint0_linear_2361_23176)" />
        <path d="M10.9991 13.396C10.9991 15.7842 7.47427 15.7842 7.47427 13.396C7.47427 11.0107 10.9991 11.0107 10.9991 13.396Z" fill="url(#paint1_linear_2361_23176)" />
        <path d="M19.5252 13.396C19.5252 15.7842 16.0004 15.7842 16.0004 13.396C16.0004 11.0107 19.5252 11.0107 19.5252 13.396Z" fill="url(#paint2_linear_2361_23176)" />
        <defs>
          <linearGradient id="paint0_linear_2361_23176" x1="4.03045" y1="3.9726" x2="33.965" y2="20.0886" gradientUnits="userSpaceOnUse">
            <stop stopColor="#262A98" />
            <stop offset="0.331731" stopColor="#518BEC" />
            <stop offset="1" stopColor="#CCABF7" />
          </linearGradient>
          <linearGradient id="paint1_linear_2361_23176" x1="4.03045" y1="3.9726" x2="33.965" y2="20.0886" gradientUnits="userSpaceOnUse">
            <stop stopColor="#262A98" />
            <stop offset="0.331731" stopColor="#518BEC" />
            <stop offset="1" stopColor="#CCABF7" />
          </linearGradient>
          <linearGradient id="paint2_linear_2361_23176" x1="4.03045" y1="3.9726" x2="33.965" y2="20.0886" gradientUnits="userSpaceOnUse">
            <stop stopColor="#262A98" />
            <stop offset="0.331731" stopColor="#518BEC" />
            <stop offset="1" stopColor="#CCABF7" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default AiAssistantIcon;